import { EntityType } from "constants/index";
import { useEffect, useState } from "react";
import { getAIMLMaterialSuggestedActivities } from "services/auth";

export function useAISuggestedActivityIdsHook(props: {
  featureId: string | undefined;
  token: any;
  entiyType: EntityType;
  isEnabled: Boolean;
}) {
  const { featureId, token, entiyType, isEnabled } = props;
  const [suggestedIds, setSuggestedIds] = useState<any>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      featureId?.trim().length &&
      isEnabled &&
      entiyType === EntityType.Material
    ) {
      const fetchSuggestedActivities = async () => {
        setLoading(true);
        const response = await getAIMLMaterialSuggestedActivities(
          token,
          featureId
        );
        setLoading(false);
        if (response?.success) {
          setSuggestedIds(response.data?.suggested_tasks);
        }
        return null;
      };

      fetchSuggestedActivities();
    }
  }, [featureId, token, entiyType, isEnabled]);

  return { suggestedIds, loading };
}
